import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import i18n from './plugins/i18n'
// main.js
// 在 main.js 或 app.js 中设置全局变量

const isMobile = window.innerWidth <= 768; // 判断是否是手机，768px 以下认为是手机





const app = createApp(App)
app.config.globalProperties.$isMobile = isMobile;

app.use(ElementPlus)
app.use(router)
app.use(i18n)

app.mount('#app')
